<template>
  <div>
    <v-card class="card-custom-shadow">
      <v-card-text class="fs-12">
        <div class="mb-2">
          <v-row no-gutters>
            <v-col cols="6" class="fs-14px black--text">Giao xe:</v-col>
            <v-col cols="6">
              <div
                v-if="order.id_branch_delivery"
                class="text-right purple--text"
              >
                Xe khả dụng: {{ showQuantity }}
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete
              v-model="order.id_account_main"
              :items="accountOptions"
              class="c-input-small"
              outlined
              dense
              hide-details
              label="Khách hàng"
              placeholder="Khách hàng"
              @change="onAccountMainChanged"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-if="order.delivery_type == 1"
              v-model="order.id_account_delivery_address"
              :items="deliveryAddressOptions"
              class="c-input-small"
              outlined
              dense
              hide-details
              label="Địa chỉ"
              placeholder="Địa chỉ"
            ></v-autocomplete>
            <v-autocomplete
              v-else
              v-model="order.id_branch_delivery"
              :items="branchOptions"
              class="c-input-small"
              outlined
              dense
              hide-details
              label="Cửa hàng"
              placeholder="Cửa hàng"
              @change="getBikeAvailable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <div class="">
              <v-radio-group
                v-model="order.time_type"
                hide-details
                dense
                class="c-input-small mt-0 mb-1"
              >
                <v-row dense>
                  <v-col cols="6">
                    <v-radio label="Giao ngay" :value="1"></v-radio>
                  </v-col>
                  <v-col cols="6">
                    <v-radio label="Hẹn giờ" :value="2"></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </v-col>
          <template v-if="order.time_type == 2">
            <v-col cols="4">
              <date-picker-model
                v-model="startDate"
                label="Ngày"
                custom-class="c-input-small"
                outlined
                dense
                hide-details
                :single-line="false"
                :min-date="minDate"
              ></date-picker-model>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                v-model="startHour"
                :items="hourOptions"
                class="c-input-small"
                outlined
                dense
                hide-details
                label="Giờ"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                v-model="startMinute"
                :items="minOptions"
                class="c-input-small"
                outlined
                dense
                hide-details
                label="Phút"
              ></v-autocomplete>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  ORDER_CREATE_DEFAULT_SUPPORT_DELIVERY,
  ORDER_PARTNER_DELIVERY_TYPE,
} from "@/libs/const";
import { httpClient } from "@/libs/http";
import moment from "moment/moment";

export default {
  name: "SupportDelivery",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    summary: {
      type: Object,
      default: () => {},
    },
    vouchers: {
      type: Array,
      default: () => [],
    },
    deliveryAddress: {
      type: Array,
      default: () => [],
    },
    accounts: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isLoading: false,
    order: { ...ORDER_CREATE_DEFAULT_SUPPORT_DELIVERY },
    deliveryTypes: [...ORDER_PARTNER_DELIVERY_TYPE],
    branches: [],
    bikeAvailable: 0,
    startDate: null,
    startHour: null,
    startMinute: null,
  }),
  computed: {
    accountOptions() {
      return [...this.accounts].map((acc) => ({
        text: acc.name,
        value: acc.id,
      }));
    },
    minDate() {
      return moment().format("YYYY-MM-DD");
    },
    startTime() {
      console.log(this.startDate, this.startHour, this.startMinute);
      if (!this.startDate || !this.startHour || !this.startMinute) {
        return null;
      }
      return `${this.startDate} ${this.startHour}:${this.startMinute}:00`;
    },
    hourOptions() {
      const today = moment().format("YYYY-MM-DD");
      const nowHour = moment().hour();
      let h = 0;
      if (this.startDate == today) {
        h = nowHour;
      }
      const hours = [];
      for (let i = 8; i < 21; i++) {
        if (i >= h) {
          hours.push(i < 10 ? `0${i}` : `${i}`);
        }
      }
      return hours;
    },
    minOptions() {
      const today = moment().format("YYYY-MM-DD");
      const nowHour = moment().hour();
      const nowMin = moment().minute();
      let m = 0;
      if (this.startDate == today && +this.startHour == nowHour) {
        m = nowMin;
      }
      const minutes = [];
      for (let i = 0; i < 60; i += 15) {
        if (i >= m) {
          minutes.push(i < 10 ? `0${i}` : `${i}`);
        }
      }
      return minutes;
    },
    deliveryAddressOptions() {
      return [...this.deliveryAddress].map((d) => ({
        text: this.capitalizeStr(`${d.name} - ${d.address}`),
        value: d.id,
      }));
    },
    branchOptions() {
      return [...this.branches].map((d) => ({
        text: d.code,
        value: d.id,
      }));
    },
    showQuantity() {
      if (!this.order.id_branch_delivery) {
        return 0;
      }
      const branch = [...this.branches].find(
        (b) => b.id == this.order.id_branch_delivery
      );

      const quantity = this.bikeAvailable - branch.min_bike;
      return quantity > 0 ? quantity : 0;
    },
  },
  watch: {
    order: {
      handler() {
        this.$emit("onUpdate", this.order);
      },
      deep: true,
    },
    startTime() {
      this.setStartTime();
    },
  },
  created() {
    if (this.info && this.info.id) {
      if (this.info.start_time) {
        this.startDate = moment(this.info.start_time).format("YYYY-MM-DD");
        this.startHour = moment(this.info.start_time).format("HH");
        this.startMinute = moment(this.info.start_time).format("mm");
      }
      this.order = {
        ...this.order,
        id_account_main: this.info.id_source || null,
        delivery_type: this.info.id_branch_delivery ? 2 : 1,
        id_account_delivery_address: this.info.id_account_delivery_address,
        id_branch_delivery: this.info.id_branch_delivery,
        start_time: this.info.start_time
          ? moment(this.info.start_time).format("YYYY-MM-DD HH:mm:ss")
          : null,
      };
    } else if (this.deliveryAddress && this.deliveryAddress.length == 1) {
      this.order = {
        ...this.order,
        delivery_type: 1,
        id_account_delivery_address: this.deliveryAddress[0].id,
      };
    }
    this.getBranch();
  },
  methods: {
    setStartTime() {
      this.order = { ...this.order, start_time: this.startTime };
    },
    onAccountMainChanged() {
      this.order = {
        ...this.order,
        id_account_delivery_address: null,
        id_branch_delivery: null,
        start_time: null,
      };
      this.$emit("onAccountMainChanged", true);
    },
    onChange(item) {
      this.order = { ...this.order, [item.name]: item.value };
    },
    onReset() {
      this.order = { ...ORDER_CREATE_DEFAULT_SUPPORT_DELIVERY };
    },
    async getBikeAvailable() {
      const branch = [...this.branches].find(
        (br) => br.id == this.order.id_branch_delivery
      );
      if (branch) {
        this.order = { ...this.order, delivery_id_city: branch.id_city };
      }
      const { data } = await httpClient.post(
        "/asset/v1/get-bike-available-by-branch",
        {
          id_branch: this.order.id_branch_delivery,
        }
      );
      this.bikeAvailable = data;
    },
    async getBranch() {
      const { data } = await httpClient.post("/me/v1/get-branch");
      this.branches = [...data];
    },
  },
};
</script>
